import { Injectable, inject } from '@angular/core';
import { State, StateContext, Action, Selector } from '@ngxs/store';
import { patch } from '@ngxs/store/operators';
import { IpDetectorActions } from './ip-detector.action';
import { GenericService } from 'src/app/services/generic.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { IpStateModel } from './ip-detector.interface';
import { catchError, tap, throwError } from 'rxjs';

@State<IpStateModel>({
	name: 'IpDetectorState',
	defaults: {
		ipData: null,
		error: null
	}
})
@Injectable()
export class IpDetectorState {
	private genericService = inject(GenericService);
	private ngxLoader = inject(NgxUiLoaderService);


	@Selector()
	static getIp(state: any) {
		if (state.error) {
			throw new Error(state.error);
		}
		return state.ipData;
	}

	@Action(IpDetectorActions.GetIp)
	getIp(context: StateContext<any>) {
		context.patchState({ error: null }); // Reset errors before fetching data
		return this.genericService.get('https://ip.cloudstaff.tech/json').pipe(
			tap((e) => {
				context.patchState({ ipData: e, error: null }); // Store successful response
			}),
			catchError((error) => {
				context.patchState({ error: 'Failed to fetch IP', ipData: null }); // Store error
				return throwError(() => error);
			})
		);
	}
}
